import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ChatMessage {
  chatId?: string | null;
  messageId?: string | null;
  role: 'user' | 'ai' | 'system';
  text: string;
  sqlQuery?: string;
}

interface ChatState {
  chatId?: string | null;
  messages: ChatMessage[];
  reloadChatlist: boolean;
}

const initialState: ChatState = {
  chatId: null,
  messages: [],
  reloadChatlist: false
};

const chatSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    startNewChat(state) {
      state.messages = [];
      state.chatId = null;
    },
    addMessage(state, action: PayloadAction<ChatMessage>) {
      const msg = action.payload
      state.messages.push(msg);
      if (state.chatId == null && msg.chatId) {
        state.reloadChatlist = true
        state.chatId = action.payload.chatId
      }
    },
    setChatId: (state, action: PayloadAction<string>) => {
      state.chatId = action.payload;
    },
    setMessages(state, action: PayloadAction<ChatMessage[]>) {
      state.messages = action.payload;
    },
    resetMessages(state) {
      state.chatId = null;
      state.messages = [];
      state.reloadChatlist = true;
    },
    doneChatListReload(state) {
      state.reloadChatlist = false;
    }
  }
});

export const { startNewChat, addMessage, setChatId, setMessages, resetMessages, doneChatListReload } = chatSlice.actions;
export default chatSlice.reducer;
